import { useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../config/firebase';

export const useAdminAuth = (userId) => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [userProfile, setUserProfile] = useState(null);

  useEffect(() => {
    if (!userId || !db) {
      setIsAdmin(false);
      setIsLoading(false);
      setUserProfile(null);
      return;
    }

    const userDocRef = doc(db, `artifacts/bz-tracker/users/${userId}`);

    const unsubscribe = onSnapshot(
      userDocRef,
      (docSnap) => {
        if (docSnap.exists()) {
          const profileData = docSnap.data();
          setUserProfile(profileData);
          setIsAdmin(profileData.isAdmin === true);
        } else {
          setUserProfile(null);
          setIsAdmin(false);
        }
        setIsLoading(false);
      },
      (error) => {
        console.error("Error fetching user profile:", error);
        setIsAdmin(false);
        setIsLoading(false);
        setUserProfile(null);
      }
    );

    return () => unsubscribe();
  }, [userId]);

  return {
    isAdmin,
    isLoading,
    userProfile
  };
};
